// Reads the `exp` (expiration) claim from a JWT without signature verification.
// Used only to schedule pre-emptive refresh — "refresh 15s before the token dies".
// Signature is the server's problem; we just need the timing.
export const decodeExp = (token: string): number | null => {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }
  try {
    const segment = parts[1];
    if (!segment) {
      return null;
    }
    const json = atob(segment.replace(/-/g, '+').replace(/_/g, '/'));
    const payload: unknown = JSON.parse(json);
    if (typeof payload !== 'object' || payload === null) {
      return null;
    }
    const exp = (payload as Record<string, unknown>)['exp'];
    return typeof exp === 'number' ? exp : null;
  } catch {
    return null;
  }
};
